import React from "react";
import { Card, ProgressBar, Spinner, Stack } from "react-bootstrap";
import { useDownloadContext } from "../../providers/DownloadProvider";

export const DownloadProgress: React.FC = () => {
  const { state } = useDownloadContext();

  if (state.phase === "IDLE") return null;

  const isCompleted = state.phase === "COMPLETED";
  const isError = state.phase === "ERROR";
  const showSpinner = state.phase !== "COMPLETED" && state.phase !== "ERROR";
  
  const percentage = state.total > 0 ? (state.completed / state.total) * 100 : 0;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 9999,
        width: "320px",
        animation: "slideIn 0.3s ease-out",
      }}
    >
      <Card
        className="shadow-lg border-0"
        style={{
          background: "rgba(255, 255, 255, 0.85)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          borderRadius: "16px",
          border: "1px solid rgba(255, 255, 255, 0.3)",
        }}
      >
        <Card.Body className="p-3">
          <Stack direction="horizontal" gap={3} className="mb-2 align-items-center">
            {showSpinner && (
              <Spinner animation="border" size="sm" variant="primary" />
            )}
            <div className="flex-grow-1">
              <h6 className="mb-0 fw-bold" style={{ fontSize: "14px", color: "#1a1a1a" }}>
                {isCompleted ? "Download Complete" : isError ? "Download Failed" : "Processing Certificates"}
              </h6>
              <small className="text-muted" style={{ fontSize: "11px" }}>
                {state.status}
              </small>
            </div>
          </Stack>

          {state.total > 0 && (
            <div className="mt-2">
              <ProgressBar 
                now={percentage} 
                variant={isCompleted ? "success" : isError ? "danger" : "primary"}
                style={{ height: "6px", borderRadius: "10px" }}
                animated={!isCompleted && !isError}
              />
              <div className="d-flex justify-content-between mt-1">
                <span style={{ fontSize: "10px", color: "#6c757d" }}>
                  {state.completed} / {state.total} certificates
                </span>
                <span style={{ fontSize: "10px", color: "#6c757d" }}>
                  {Math.round(percentage)}%
                </span>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};
